/**
 * search.js
 */

import { options } from "../../exports/autocomplete";


scrollTo('#courses', 80);
$("input#course-name").autocomplete(options.defaults);
